import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { OnboardingStatus } from '../../shared/model/onboarding-status.dto';
import { ApiService } from './api.service';

/**
 * Single source of truth for signup wizard (onboarding) completion.
 * Completion is derived server-side from persisted per-step state; this service
 * only adds an in-memory override for the navigation immediately after the final
 * wizard step is saved, so we don't depend on a refetch timing.
 */
@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  private readonly API_NAME = 'client';

  private justCompleted = false;

  constructor(private apiService: ApiService) {}

  public getStatus(): Observable<OnboardingStatus> {
    if (this.justCompleted) {
      return of({
        mobileVerified: true,
        termsAcceptedCurrent: true,
        commsPreferencesSet: true,
        completed: true
      });
    }

    return this.apiService.get(this.API_NAME, 'onboarding/status');
  }

  public markCompleted(): void {
    this.justCompleted = true;
  }

  /**
   * Clears the in-memory completion override. Must be called on logout / user
   * change so a freshly-logged-in user in the same SPA instance doesn't inherit
   * the previous user's completed state and skip the sign-up wizard.
   */
  public reset(): void {
    this.justCompleted = false;
  }
}
